import React from "react";
import PropTypes from "prop-types";
import { FormControlLabel, Checkbox } from "@mui/material";
import MotionCheck from "../../Icons/MotionCheck";

const EMPCheckbox = ({
  disabled = false,
  required = false,
  name,
  label,
  ariaLabel,
  value,
  id,
  handleChange,
  checked = false,
}) => {
  function onChange(e) {
    handleChange(e.target.checked);
  }

  return (
    <FormControlLabel
      disabled={disabled}
      data-testid={id}
      sx={{ margin: 0 }}
      slotProps={{
        typography: {
          variant: "body2",
          sx: {
            marginLeft: (theme) => theme.spacing(2),
          },
        },
      }}
      control={
        <Checkbox
          id={id}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          required={required}
          disableRipple
          name={name}
          checkedIcon={<MotionCheck />}
          icon={<span />}
          inputProps={{ "aria-label": ariaLabel }}
          color="primary"
          value={value}
          sx={{ flex: "0 0 24px" }}
        />
      }
      label={label}
    />
  );
};

EMPCheckbox.propTypes = {
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  label: PropTypes.node,
  ariaLabel: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]),
  id: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
};

export default EMPCheckbox;
